import TermsAndCondition from '../views/TermsAndCondition.vue';
import SidekickSearch from '../views/SidekickSearch.vue';
import BloxSearch from '../views/Blox.vue';
import AboutUs from '../views/AboutUs.vue';

const routes = [
  {
    path: '/',
    component: SidekickSearch,
    name: 'SNKRHUD',
  },
  {
    path: '/snkrhud',
    component: SidekickSearch,
    name: 'SNKRHUD',
  },
  {
    path: '/bl0x',
    component: BloxSearch,
    name: 'Bl0x',
  },
  {
    path: '/about-us',
    component: AboutUs,
    name: 'AboutUs',
  },
  {
    path: '/terms-and-condition',
    component: TermsAndCondition,
    name: 'TermsAndCondition',
  },
];

export default routes;
